import { startCase } from 'lodash-es'

export function mapValueToSelectOption<T extends string>(
  value: T,
  labelMapper?: (value: T) => string
): { label: string; value: T }
export function mapValueToSelectOption<T extends string, V>(
  value: T,
  labelMapper: (value: T) => string,
  valueMapper: (value: T) => V
): { label: string; value: V }
export function mapValueToSelectOption<T extends string, V = T>(
  value: T,
  labelMapper: (value: T) => string = startCase,
  valueMapper?: (value: T) => V
) {
  return {
    label: labelMapper(value),
    value: valueMapper ? valueMapper(value) : value,
  }
}

export function makeValueToSelectOptionMapper<T extends string>(
  labelMapper?: (value: T) => string
): (value: T) => { label: string; value: T }
export function makeValueToSelectOptionMapper<T extends string, V>(
  labelMapper: (value: T) => string,
  valueMapper: (value: T) => V
): (value: T) => { label: string; value: V }
export function makeValueToSelectOptionMapper<T extends string, V = T>(
  labelMapper: (value: T) => string = startCase,
  valueMapper?: (value: T) => V
) {
  return (value: T) => ({
    label: labelMapper(value),
    value: valueMapper ? valueMapper(value) : value,
  })
}

export function mapValuesToSelectOptions<T extends string>(
  values: T[],
  labelMapper?: (value: T) => string
): { label: string; value: T }[]
export function mapValuesToSelectOptions<T extends string, V>(
  values: T[],
  labelMapper: (value: T) => string,
  valueMapper: (value: T) => V
): { label: string; value: V }[]
export function mapValuesToSelectOptions<T extends string, V = T>(
  values: T[],
  labelMapper: (value: T) => string = startCase,
  valueMapper?: (value: T) => V
) {
  return values.map((value) => ({
    label: labelMapper(value),
    value: valueMapper ? valueMapper(value) : value,
  }))
}
